import SelectedRowsCounter from './SelectedRowsCounter'

export default SelectedRowsCounter
